/* eslint react/no-danger: 0 */  // --> OFF
import PropTypes from "prop-types";
import React, { Component } from "react";

export default class ReadOnlyField extends Component {
  constructor(props) {
    super(props);
    this.getFieldClassName = this.getFieldClassName.bind(this);
  }

  rawMarkup(fieldValue) {
    return { __html: fieldValue };
  }

  getFieldClassName(fieldValue) {
    if (fieldValue === "Not Provided") {
      return "";
    } else {
      return " offset";
    }
  }

  render() {
    let {
      fieldValue,
      title,
      rawHtml,
      link,
      emailLink,
      emptyText,
      containerClassName
    } = this.props;

    if (this.props.hideIfNoValue && !fieldValue) return null;

    if (
      fieldValue == undefined ||
      fieldValue == null ||
      fieldValue.length == 0 ||
      fieldValue === " "
    ) {
      fieldValue =
        emptyText == undefined || emptyText.length == 0
          ? "Not provided"
          : emptyText;
    }

    let fValFunc = () => {
      return (
        <div>
          {rawHtml === true ? (
            <div
              className={"md-full-width read-only-field-value" + this.getFieldClassName(fieldValue)}
              dangerouslySetInnerHTML={this.rawMarkup(fieldValue)}
            />
          ) : (
            <div className={"md-full-width read-only-field-value" + this.getFieldClassName(fieldValue)}>
              {fieldValue}
            </div>
          )}
        </div>
      );
    };
    let fVal = fValFunc();

    let singleLineStyle = this.props.singleLine
      ? { style: { display: "flex", justifyContent: "space-between" } }
      : null;
    let singleLineStyle2 = this.props.singleLine
      ? { style: { paddingRight: "15px", whiteSpace: "nowrap" } }
      : null;
    let singleLineStyle3 = this.props.singleLine
      ? { style: { whiteSpace: "nowrap" } }
      : null;

    if(emailLink)
    {
      link=`mailto:${fieldValue}`;
    }

    return (
      <div
        {...singleLineStyle}
        className={`${containerClassName} md-text-field-container md-full-width md-text-field-container--disabled md-text-field-container--input`}
      >
        <div
          {...singleLineStyle2}
          className={"md-floating-label--disabled read-only-title field-label"}
        >
          {title}
        </div>
        <div
          className="field-value"
        >
        {link ? (
          <a href={link} {...!emailLink && {target: "_blank"}}>
            {fVal}
          </a>
        ) : (
          <div {...singleLineStyle3}>{fVal}</div>
        )}
        </div>
      </div>
    );
  }
}

ReadOnlyField.propTypes = {
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
  title: PropTypes.string,
  rawHtml: PropTypes.bool,
  link: PropTypes.string,
  emailLink: PropTypes.bool,//this is needed because the link prop above will open the link in a new tab and thats bad, also this will craft the email link for you so you dont have to
  emptyText: PropTypes.string,
  containerClassName: PropTypes.string,
  singleLine: PropTypes.bool,
  hideIfNoValue: PropTypes.bool
};
